import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import * as DOMPurify from 'dompurify';
import { useTranslation as useTranslationHook } from '../../../abstractions/hooks/useTranslation';
export var Translation = function (_a) {
    var id = _a.id, fallback = _a.fallback, values = _a.values, dangerouslySetInnerHTML = _a.dangerouslySetInnerHTML, _b = _a.useTranslation, useTranslation = _b === void 0 ? useTranslationHook : _b;
    var translate = useTranslation().translate;
    var copy = translate({ id: id, values: values, fallback: fallback });
    if (dangerouslySetInnerHTML)
        return (_jsx("span", { dangerouslySetInnerHTML: {
                __html: DOMPurify.sanitize(copy),
            } }));
    return _jsx(_Fragment, { children: copy });
};
export * from './Translation.types';
Translation.displayName = 'Translation';
